'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
const __endpoints = require('endpoints.service');

export default class TurnoverAchievementsRulesList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'period',
				type: 'date',
				canAdd: true,
				canEdit: true,
				required: true,
				reference: {
					key: 'from',
					translationKey: 'FROM',
				},
			},
			{
				name: 'period',
				type: 'date',
				canAdd: true,
				canEdit: true,
				required: true,
				reference: {
					key: 'to',
					translationKey: 'TO',
				},
			},
			{
				name: 'percentage',
				type: 'number',
				canAdd: true,
				canEdit: true,
				required: true,
			},
		];
		this.settings = {
			name: 'TurnoverAchievementsRulesList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			alwaysRefresh: true,
			translationPath: 'REPORTING.TURNOVER_ACHIEVEMENTS_RULES',
			endpoint: __endpoints.collection.reporting.turnover_achievements_rules,
		};
		this.init();
		return this;
	}
}
